import React from "react";
import { useTranslation } from "react-i18next";
import FormField from "../../Common/FormField";
import { INFO_FIELDS } from "../../Common/constants";
import { getInfoFields } from "../../Common/utils";
import {Hint} from "@americanexpress/dls-react";

const CompanyInfoSection = ({ formik, country }) => {
  const { t } = useTranslation("common");

  const companyInfoFields = getInfoFields(country, INFO_FIELDS.COMPANYINFO, t);
  const isIEC = country === t(`access.INTERNATIONALEUROCARD`);

  return (
    <section id="company-info">
      <div className="row">
        <div className="col-xs-12">
          <h4 className="heading-4 dls-deep-blue pad-2-t pad-2-b">
            {t("newUserUK.companyInfoHeading")}
          </h4>
          <Hint className="legal-1 pad-2-b">
            {isIEC ? t("newUserUK.companySubText") : null}
          </Hint>
        </div>
        <FormField
          id="bussRegName"
          name="bussRegName"
          label={companyInfoFields.bussRegName}
          value={formik.values.bussRegName}
          onBlur={formik.handleBlur}
          onChange={formik.handleChange}
          error={formik.touched.bussRegName && formik.errors.bussRegName}
        />
        <FormField
          id="bussRegAddress"
          name="bussRegAddress"
          label={companyInfoFields.bussRegAddress}
          value={formik.values.bussRegAddress}
          onBlur={formik.handleBlur}
          onChange={formik.handleChange}
          error={formik.touched.bussRegAddress && formik.errors.bussRegAddress}
        />
        <FormField
          id="bussRegPostcode"
          name="bussRegPostcode"
          label={companyInfoFields.bussRegPostcode}
          value={formik.values.bussRegPostcode}
          onBlur={formik.handleBlur}
          onChange={formik.handleChange}
          error={
            formik.touched.bussRegPostcode && formik.errors.bussRegPostcode
          }
        />
        <FormField
          id="bussRegCountry"
          name="bussRegCountry"
          label={companyInfoFields.bussRegCountry}
          value={formik.values.bussRegCountry}
          onBlur={formik.handleBlur}
          onChange={formik.handleChange}
          error={formik.touched.bussRegCountry && formik.errors.bussRegCountry}
        />
        {!isIEC && (
          <FormField
            id="organisationNumber"
            name="organisationNumber"
            label={t("newuser.organisationNumber")}
            value={formik.values.organisationNumber}
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            error={
              formik.touched.organisationNumber &&
              formik.errors.organisationNumber
            }
          />
        )}
      </div>
    </section>
  );
};

export default CompanyInfoSection;
